var map = {
	"./de-DE.json": [
		1169,
		10
	],
	"./en-US.json": [
		288
	],
	"./es-ES.json": [
		1170,
		11
	],
	"./fr-FR.json": [
		1171,
		12
	],
	"./it-IT.json": [
		1172,
		13
	],
	"./ja-JP.json": [
		1173,
		14
	],
	"./ko-KR.json": [
		1174,
		15
	],
	"./pl-PL.json": [
		1175,
		16
	],
	"./pt-BR.json": [
		1176,
		17
	],
	"./ru-RU.json": [
		1177,
		18
	],
	"./th-TH.json": [
		1178,
		19
	],
	"./tr-TR.json": [
		1179,
		20
	],
	"./zh-CN.json": [
		1180,
		21
	],
	"./zh-TW.json": [
		1181,
		22
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__.t(id, 3);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 918;
module.exports = webpackAsyncContext;